export const pageStickyHeightCssVar = '--page-sticky-height';
